
<template>
  <v-form ref="signUpForm" v-model="formValid">
    <v-text-field
      :label="usernameLabel"
      :solo="solo"
      :clearable="clearable"
      :solo-inverted="soloInverted"
      :color="color"
      :flat="flat"
      :dense="dense"
      :filled="filled"
      :disabled="disabled"
      :style="styles['username']"
      :class="classes['username']"
      :rules="[rules.required]"
      v-model="localUsername"
    ></v-text-field>

    <v-text-field
      :label="emailLabel"
      :solo="solo"
      :clearable="clearable"
      :solo-inverted="soloInverted"
      :color="color"
      :flat="flat"
      :dense="dense"
      :filled="filled"
      :disabled="disabled"
      :style="styles['email']"
      :class="classes['email']"
      :rules="[rules.required, rules.email]"
      v-model="localEmail"
    ></v-text-field>

    <v-text-field
      counter
      hint="At least 8 characters"
      :label="passwordLabel"
      :solo="solo"
      :flat="flat"
      :color="color"
      :dense="dense"
      :filled="filled"
      :disabled="disabled"
      :clearable="clearable"
      :solo-inverted="soloInverted"
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :type="showPassword ? 'text' : 'password'"
      :style="styles['password']"
      :class="classes['password']"
      :rules="[rules.required]"
      @click:append="showPassword = !showPassword"
      v-model="localPassword"
    ></v-text-field>

    <v-text-field
      :label="confirmPasswordLabel"
      :solo="solo"
      :flat="flat"
      :color="color"
      :dense="dense"
      :filled="filled"
      :disabled="disabled"
      :clearable="clearable"
      :solo-inverted="soloInverted"
      v-model="localConfirmPassword"
      :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :rules="[rules.required]"
      :type="showConfirmPassword ? 'text' : 'password'"
      hint="At least 8 characters"
      counter
      @click:append="showConfirmPassword = !showConfirmPassword"
      :style="styles['confirmPassword']"
      :class="classes['confirmPassword']"
    ></v-text-field>
    <div
      v-if="goToLoginButton"
      class="pa-3 text-center"
      style="font-size: 10pt"
      :class="classes['goToLoginButton']"
      :style="styles['goToLoginButton']"
    >
      <slot name="goToLoginButton" v-bind:emit="emit">
        Do you already have an account?
        <a v-on:click.prevent="emit('to-login')">Log In</a>
      </slot>
    </div>

    <div
      class="d-flex"
      :class="{
        'justify-center': signUpButtonAlignment == 'center',
        'justify-end': signUpButtonAlignment == 'right',
        'justify-start': signUpButtonAlignment == 'left',
      }"
    >
      <v-btn
        :color="signUpButtonColor ? signUpButtonColor : color"
        :block="signUpButtonBlock"
        :outlined="signUpButtonOutlined"
        :style="styles['password']"
        :disabled="disabled || (disabledWhenNotValid && !formValid)"
        @click="
          emit(
            'signUp-click',
            localUsername,
            localEmail,
            localPassword,
            localConfirmPassword
          )
        "
        >SignUp</v-btn
      >
    </div>
  </v-form>
</template>

<script>
import emittable from '../../../mixins/emittable'
import formValidable from '../../../mixins/formValidable'

import {
  VForm,
  VTextField,
  VBtn
} from 'vuetify/lib'

export default {
  name: "SignUpFormComponent",
  components: {
    VForm,
    VTextField,
    VBtn
  },
  mixins: [emittable, formValidable],
  data: function () {
    return {
      //TODO Filippo: passare tutti i valori come param e non un oggetto?
      localUsername: this.username,
      localEmail: this.email,
      localPassword: this.password,
      localConfirmPassword: this.confirmPassword,
      showPassword: false,
      showConfirmPassword: false,
      formValid: undefined,
    };
  },
  mounted() {
    if (this.bus) {
      this.bus.on("reset-validation", function () {
        this.$refs.signUpForm.resetValidation();
      });

      this.bus.on("reset", function () {
        this.$refs.signUpForm.reset();
      });
    }
  },
  props: {
    bus: {
      type: Object,
      default: undefined,
    },
    goToLoginButton: {
      type: Boolean,
      default: false,
    },
    username: {
      type: String,
      default: undefined,
    },
    email: {
      type: String,
      default: undefined,
    },

    password: {
      type: String,
      default: undefined,
    },
    confirmPassword: {
      type: String,
      default: undefined,
    },
    usernameLabel: {
      type: String,
      default: "Username",
    },
    passwordLabel: {
      type: String,
      default: "Password",
    },
    confirmPasswordLabel: {
      type: String,
      default: "Confirm Password",
    },
    emailLabel: {
      type: String,
      default: "Email",
    },
    color: {
      type: String,
      default: "primary",
    },
    solo: {
      type: Boolean,
      default: false,
    },
    soloInverted: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledWhenNotValid: {
      type: Boolean,
      default: true,
    },
    signUpButtonAlignment: {
      type: String,
      default: "center",
      validator: function (value) {
        return ["left", "center", "right"].indexOf(value) !== -1;
      },
    },
    signUpButtonOutlined: {
      type: Boolean,
      default: true,
    },
    signUpButtonBlock: {
      type: Boolean,
      default: true,
    },
    signUpButtonColor: {
      type: String,
      default: "yellow",
    },
    styles: {
      type: Object,
      default: function () {
        return {
          username: {},
          email: {},
          password: {},
          confirmPassword: {},
          signUpButton: {},
          goToLoginButton: {},
        };
      },
    },
    classes: {
      type: Object,
      default: function () {
        return {
          username: {},
          email: {},
          password: {},
          confirmPassword: {},
          signUpButton: {},
          goToLoginButton: {},
        };
      },
    },
  },

  methods: {},
  watch: {
    username: function (newVal) {
      this.localUsername = newVal;
    },

    email: function (newVal) {
      this.localEmail = newVal;
    },
    password: function (newVal) {
      this.localPassword = newVal;
    },
    confirmPassword: function (newVal) {
      this.localConfirmPassword = newVal;
    },
  },
};
</script>

<style>
</style>